import React, { useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import { useQuery } from 'react-query';
import { motion } from 'framer-motion';
import { FiFileText } from 'react-icons/fi';
import { api } from '../api';
import Breadcrumb from '../components/Breadcrumb';

const SectionCard = ({ section, index }) => {
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ delay: index * 0.1 }}
      className="bg-white rounded-xl shadow-md overflow-hidden mb-4"
    >
      {/* Section Header */}
      <div className="p-6 border-b border-gray-100">
        <div className="flex items-center space-x-4">
          <div className="w-10 h-10 bg-lodge-brown-100 rounded-lg flex items-center justify-center">
            <FiFileText className="w-5 h-5 text-lodge-brown-600" />
          </div>
          <h3 className="text-lg font-semibold text-mountain-gray-800">
            {section.title}
          </h3>
        </div>
      </div>

      {/* Section Content */}
      <div className="p-6">
        <div 
          className="prose prose-sm max-w-none content-styles"
          dangerouslySetInnerHTML={{ __html: section.content }}
        />
      </div>
    </motion.div>
  );
};

const CategoryPage = () => {
  const { slug } = useParams();
  const { data: categoryResponse, isLoading, error } = useQuery(
    ['category', slug],
    () => api.getCategory(slug)
  );
  
  const category = categoryResponse?.data;

  if (isLoading) {
    return (
      <div className="flex items-center justify-center min-h-[60vh]">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-lodge-brown-600"></div>
      </div>
    );
  }

  if (error || !category) {
    return (
      <div className="text-center py-12">
        <h2 className="text-2xl font-display text-mountain-gray-700">Category not found</h2>
        <Link to="/" className="text-lodge-brown-600 hover:text-lodge-brown-700 mt-4 inline-block">
          ← Back to Home
        </Link>
      </div>
    );
  }

  const { name, sections } = category;

  return (
    <div className="max-w-4xl mx-auto">
      <Breadcrumb />
      
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
      >
        <h1 className="text-3xl md:text-4xl font-display text-lodge-brown-800 mb-8">
          {name}
        </h1>

        {sections && sections.length > 0 ? (
          <div>
            {sections.map((section, index) => (
              <SectionCard key={section.id} section={section} index={index} />
            ))}
          </div>
        ) : (
          <div className="text-center py-12 bg-gray-50 rounded-xl">
            <p className="text-mountain-gray-600">No sections available in this category yet.</p>
          </div>
        )}

      </motion.div>
    </div>
  );
};

export default CategoryPage;